module.exports = __webpack_public_path__ + "static/media/comment-tip.28d5b8ee359c2fc0d3564eedcbdc1d62.svg";